import { Component, Input, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { SasisopaService } from '../../../../../services/sasisopa.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as moment from 'moment';
import { getYearsForSelect } from '../../../../../helpers/utils';

type Row = {
  id: string;
  aa_activity: string;
  aa_personal: 'c' | 'i';
  aa_resource: string;
  aa_aspect_amb: string;
  ia_facts: string;
  ia_indicators: string;
  ia_activity: string;
  ia_impact: string;
  ia_description: string;
  e_caracter: string;
  e_efecto: string;
  e_magnitud: string;
  e_extension: string;
  e_momento: string;
  e_persistencia: string;
  e_reversibilidad : string;
  e_recuperabilidad: string;
  e_sinergia: string;
  e_acumulacion: string;
  e_periodicidad: string;
  e_importancia: string;
  m_req_leg: string;
  m_description: string;
}

const emptyForm: Row = {
  id: '',
  aa_activity: '',
  aa_personal: 'c',
  aa_resource: '',
  aa_aspect_amb: '',
  ia_facts: '',
  ia_indicators: '',
  ia_activity: '',
  ia_impact: '',
  ia_description: '',
  e_caracter: '',
  e_efecto: '',
  e_magnitud: '',
  e_extension: '',
  e_momento: '',
  e_persistencia: '',
  e_reversibilidad :'',
  e_recuperabilidad: '',
  e_sinergia: '',
  e_acumulacion: '',
  e_periodicidad: '',
  e_importancia: '',
  m_req_leg: '',
  m_description: ''
};

@Component({
  selector: 'ngx-procedure-dos-formato-dos-uno',
  templateUrl: './formato-dos-uno.component.html',
})
export class FormatoDosUnoComponent implements OnInit {
  @Input() stationId: string;
  keyFormat='p_2_1'
  source: LocalDataSource;
  row = { ...emptyForm }
  loading = false
  year = moment().format('YYYY');
  years = getYearsForSelect();
  settings = {
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        // {
        //   name: 'download',
        //   title: '<img src="assets/images/icons/download.png" width="25px">',
        // },
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.png" width="25px">',
        },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      aa_activity: {
        title: 'Actividad',
        filter: true,
      },
      aa_resource: {
        title: 'Recurso',
        filter: true,
      },
      aa_aspect_amb: {
        title: 'Aspecto ambiental',
        filter: true,
      },
      aa_personal: {
        title: 'Personal',
        filter: true,
      },

    },
    noDataMessage: 'Sin registros',
  };

  constructor(
    private readonly sasisopaService: SasisopaService,
  ) {}

  ngOnInit() {
    this.loadData()
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes.record?.currentValue?.rows) {
  //     this.source = new LocalDataSource(changes.record.currentValue.rows)
  //   }
  // }

  async loadData () {
    this.loading = true;
    this.row = { ...emptyForm };
    const [error, response] = await this.sasisopaService.getInfoProcedureNew(this.stationId, this.keyFormat, this.year);
    this.loading = false;
    if (error) {
      this.alert('Error al cargar los datos', 'error', error.message);
      return;
    }
    console.log('🚀 ~ FormatoDosUnoComponent ~ loadData ~ response:', response)
    this.source = new LocalDataSource(response.map(e => (
      {
        ...e,
        aa_activity: e.data.aa_activity,
        aa_resource: e.data.aa_resource,
        aa_aspect_amb: e.data.aa_aspect_amb,
        aa_personal: e.data.aa_personal
      }
    )))
  }

  async onCustom(event: { action: string; data: { data: any, id: string }; }) {
    this.row = event.data.data;
    this.row.id = event.data.id;
    if (event.action === 'delete') {
      // @ts-ignore
      $('#delete-document').modal('show');
    } else if (event.action === 'edit') {
      // @ts-ignore
      $('#create-document').modal('show');

    } else if (event.action === 'download') {
      this.download();
    }
  }

  async remove () {
    this.loading = true;
    const [error] = await this.sasisopaService.removeInfoProcedureNew(this.row.id);
    this.loading = false;
    if (error) {
      this.alert('Error al eliminar', 'error', error.message);
      return;
    }
    this.alert('Éxito', 'success', 'Operación realizada con éxito');
    this.loadData()
    // @ts-ignore
    $('#delete-document').modal('hide');
  }

  async storeOrUpdate () {
    this.loading = true;
    if (this.row.id) {
      const [error,] = await this.sasisopaService.updateInfoProcedureNew(
        this.row.id,
        { data: this.row }
      );
      this.loading = false;
      if (error) {
        this.alert('Error al guardar los datos', 'error', error.message);
        return;
      }
      this.loading = false;
    } else {
      const [error] = await this.sasisopaService.storeInfoProcedureNew(
        this.stationId,
        { data: this.row, year: this.year, key: this.keyFormat }
      );
      this.loading = false;
      if (error) {
        this.alert('Error al guardar los datos', 'error', error.message);
        return;
      }
    }
    this.alert('Éxito', 'success', 'Operación realizada con éxito');
    this.loadData()
    // @ts-ignore
    $('#create-document').modal('hide');
  }

  async download () {
    await this.sasisopaService.downloadSasisopaFormat({
      stationId: this.stationId,
      procedure: '2',
      format: '1',
      year: this.year
    });
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}

